// Import styles - this will be separated in webpack by default
import './components/mobile-menu';
import './components/accordion';
import './components/archive-hero';
import './components/sliders';
import './components/information-bar';
import './components/single-product';
import './components/quantity';
import './components/checkout';
import './components/sticky-menu';
import './components/anchor-links';
import './components/my-account';
import './components/back-button';
import './components/search';
import './modules/newsletter';
import './modules/faq';
import './modules/maps';
import MiniCart from './components/mini-cart';

// Instantiate the minicart react app.
// This only occurs if the default WC cart widget is used.
const miniCart = document.querySelector( '.widget_shopping_cart' );
if ( miniCart ) {
	new MiniCart();
}
